import React, { useState, useEffect } from "react";
import Table from "../../../../../Components/UiComponents/Table/Table";
import { useNavigate } from "react-router-dom";
import {
  Editicon,
  Deleteicon,
  PaperClipIcon,
} from "../../../../../Components/IconComponents";
import { useDispatch } from "react-redux";
import { SopInstancedata, viewtaskcolumnsForExportView } from "../../../../../JsonData/CreateTaskConfig";
import { setTableData } from "../../../../../CentralStore/ExportLMSTable/dataSlice";
import {
  downloadFile,
  getExportedColumnsData,
} from "../../../../../Components/UiComponents/utils";
import { getTaskListURL, deleteTaskURL, sopInstanceList } from "../../../../../Services/EndPoints";
import { getData, putDataWithBody } from "../../../../../Services/Services";
import Moment from "react-moment";
import { toast } from "react-toastify";
import Confirmpopup from "../../../Common/ConfirmPopup/Confirmpopup";
import Loader from "react-spinner-loader";
import { useTranslation } from "react-i18next";

const SopInstanceTable = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [viewTypeData, setViewTypeData] = useState([]);
  const [incidentTypeData, setIncidentTypeData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    getTaskLists();
  }, []);

  useEffect(() => {
    sendDataToCentralStore(searchData);
  }, [searchData]);

  const getShortenedText = (strLength, fulltext) => {
    let abbreviatedText = "";
    if (fulltext.length > strLength) {
      abbreviatedText = fulltext.substring(0, 25) + "...";
    } else {
      abbreviatedText = fulltext;
    }
    return <span title={fulltext}>{abbreviatedText}</span>;
  };
  
  async function getTaskLists() {
    setLoader(true);
    var taskList = await getData(sopInstanceList);
    // Add sequence number to each row
    const taskListWithSequence = taskList.map((item, index) => ({
      ...item,
      sequenceNo: index + 1
    }));
    setLoader(false);
    setData(taskListWithSequence);
    setRowCount(taskListWithSequence.length);
    console.log(data,"dddddddddddddddddddddddddddddddddddd")
  }
  
  function addNewHandler() {
    navigate("/planning/create-task");
  }

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = SopInstancedata;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("S.No."), // Changed from "id" to "srno" (serial number)
        accessor: "sequenceNo", // Changed from "id" to "sequenceNo"
        disableSortBy: true,
        Cell: (props) => {
          return props.value || props.row.index + 1;
        },
      },
      {
        Header: t("sopinstancelist.name"),
        accessor: "name",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return  props.value;
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("sopinstancelist.sop"),
        accessor: "sop",
        disableSortBy: true,
      },
      {
        Header: t("sopinstancelist.incident"),
        accessor: "incident",
        Cell: (props) => {
          if (props.value) {
            return  props.value;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("sopinstancelist.status"),
        accessor: "status",
        disableSortBy: true,
        Cell: ({ value }) => {
          if (!value) return t("NA");
        
          const statusMap = {
            Started: { color: "#519EFE", label: t("Started") },
            "In-Progress": { color: "orange", label: t("In Progress") },
            Completed: { color: "green", label: t("Completed") },
            Cancel: { color: "Red", label: t("Canceled") },
            Closed: { color: "Gray", label: t("Closed") },
          };
        
          const status = statusMap[value];
        
          return status ? (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  backgroundColor: status.color,
                  borderRadius: "50%",
                }}
              ></span>
              {status.label}
            </div>
          ) : (
            t("NA")
          );
        },
        disableSortBy: false,
      },        
      {
        Header: t("sopinstancelist.createdby"),
        accessor: "created_by",
        disableSortBy: true,
      },
      {
        Header: t("sopinstancelist.createdon"),
        accessor: "created_on",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD/MM/YYYY, hh:mm a">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
        disableSortBy: false,
      },
      {
        Header: t("sopinstancelist.action"),
        disableSortBy: true,
        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const deletePopUp = () => {
            setIsdelete(!isdelete);
          };
          const deleteTableDataById = async (id) => {
            let data = { id: id };
            var res = await putDataWithBody(deleteTaskURL, data, {});
            if (res.status == "success") {
              getTaskLists();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000, // Close after 2 seconds
            });
            setIsdelete(false);
          };

          return (
            <div className="usertable__actionsicon">
              <span
                onClick={() => {
                  navigate("../sops-instance", {
                    state: {
                      data: props.row.original,
                    },
                  });
                }}
              >
                <Editicon value={props.value} className="cursor-pointer me-2" />
              </span>

              {/* <span onClick={deletePopUp}>
                <Deleteicon
                  value={props.value}
                  className="cursor-pointer mr-1"
                />
              </span>
              {isdelete && (
                <Confirmpopup
                  className="DeltePopup"
                  show={isdelete}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={props.row.original.title}
                  deleteRow={deleteTableDataById}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )} */}
            </div>
          );
        },
      },
    ],
    [t]
  );

  return (
    <div>
      <div className="create-user">
        <Loader
          show={loader}
          type="body"
          stack="vertical"
          message="Loading Data"
        />
        <div className="datatable__container">
          <Table
            data={data}
            title=""
            // addButtonLabel={t("Download")}
            // addNewHandler={addNewHandler}
            showFilter={false}
            setSearchData={setSearchData}
            columns={columns}
            numberOfRows={10}
            showExport={false}
            showReset={false}
            onExpand={false}
            showSearch={true}
            isHeaderFixed={true}
            rowCount={rowCount}
            headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid #f0f0f0",
              padding: "2px",
              borderRadius: "12px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SopInstanceTable;